import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import Container from '@mui/material/Container'
import SubImportMenuItem from './SubImportMenuItem'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import EditableSelect from '../EditableSelect'
import TextField from '@mui/material/TextField'

import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { SubImportContext } from './SubImportContext'
import { DialogsContext, DialogsProvider } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import FormLabel from '@mui/material/FormLabel'
import FormControlLabel from '@mui/material/FormControlLabel'

import Switch from '@mui/material/Switch'

import axios from 'axios'
import qs from 'qs'

import { slugifyString, convertGPTResponsesToArray } from '../../utils/index'
import ImportingNotice from './ImportingNotice'
import { importErrorMessage } from './importError'


const steps = ['Source', 'Settings', 'Processing']

export default function MindMapImportDialog({
    presetContext = '',
    presetSearchString = '',
    open,
    onClose,
}) {
    // ...existing hooks and state

    // Handler to insert ']] ' on Tab if inside unclosed [[... context
    const handleWikiTab = e => {
        if (e.key === 'Tab') {
            const textarea = e.target
            const value = textarea.value
            const selectionStart = textarea.selectionStart
            const selectionEnd = textarea.selectionEnd

            // Text before and after cursor
            const before = value.slice(0, selectionStart)
            const after = value.slice(selectionEnd)

            // Find the last occurrence of '[[', and check if there is a closing ']]' after it before the cursor
            const lastOpen = before.lastIndexOf('[[')
            const lastClose = before.lastIndexOf(']]')

            if (lastOpen !== -1 && lastOpen > lastClose) {
                // Inside an unclosed [[ ... ]]
                e.preventDefault()

                // Insert ']] ' at the cursor
                const newValue = before + ']] ' + after
                // Update the value using your existing handler
                handleSearchStringChange({
                    target: {
                        value: newValue,
                    },
                })

                // Set cursor position after the inserted text (asynchronously)
                setTimeout(() => {
                    textarea.selectionStart = textarea.selectionEnd =
                        selectionStart + 3
                }, 0)
            }
        }
    }
    const theme = useTheme() // hook to get the current theme

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const {
        activeImportDialog,
        setActiveImportDialog,
        openImportDialog,
        closeImportDialog,
        setPresetSearchString,
    } = React.useContext(DialogsContext)

    // Shared across all import sources so the typed query persists when switching
    const searchString = presetSearchString
    const setSearchString = setPresetSearchString

    const [selectedContext, setSelectedContext] = React.useState(presetContext)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [numberOfResults, setNumberOfResults] = React.useState('10')

    const [modelToUse, setModelToUse] = React.useState('gpt4')

    const [hideSearchTerms, setHideSearchTerms] = React.useState(true)

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const { username } = React.useContext(UserContext)
    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const [activeStep, setActiveStep] = React.useState(1)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    React.useEffect(() => {
        if (activeSubImportDialog.type) {
            setActiveStep(1)
            setActiveImportDialog(activeSubImportDialog.type)
        }
    }, [activeSubImportDialog])

    const submitDataForm = () => {
        const redirectUrl = fromInsideContext
            ? ``
            : `/${username}/${selectedContext}/mindmap`

        const dataToSend = {
            context: selectedContext,
            addedContexts: selectedContext,
            entry: { body: searchString },
            redirectUrl: redirectUrl,
            contexttype: 'ontology',
            wikilinks: 'entities',
            modifyAnalyzedText: modifyAnalyzedText,
            replaceEntities: replaceEntities,
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post(`/post`, dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    console.error(`Did't receive any response from the server.`)
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(1)
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleNumberOfResultsChange = event => {
        setNumberOfResults(event.target.value)
    }

    const handleSearchStringChange = event => {
        setSearchString(event.target.value)

        // const selectedText = getSelected().toString()

        // let statementToReplace = event.target.value

        // if (
        //     statementToReplace.indexOf('@' + selectedText) === -1 &&
        //     selectedText !== statementToReplace &&
        //     selectedText.length > 1 &&
        //     selectedText != ' ' &&
        //     selectedText != '  ' &&
        //     selectedText.slice(selectedText.length - 2).indexOf(']') == -1
        // ) {
        //     let regex = RegExp(selectedText, 'g')

        //     let dasherized = selectedText

        //     let replacedString

        //     dasherized = selectedText.replace(/\s+/g, '_').replace(/^\_/, '')

        //     replacedString = statementToReplace
        //         .replace(regex, '[[' + dasherized + ']]')
        //         .replace(/##/g, '#')

        //     setSearchString(replacedString)
        // }
    }

    const handleSearchStringSelect = event => {
        const target = event.target
        const value = target.value
        const selectionStart = target.selectionStart
        const selectionEnd = target.selectionEnd

        // Check if the entire text is selected or if the selection is just spaces or punctuation
        if (
            (selectionStart === 0 && selectionEnd === value.length) ||
            !/\S/.test(value.substring(selectionStart, selectionEnd))
        ) {
            return // Don't proceed if the entire text is selected or if the selection is just spaces/punctuation
        }

        const selectedText = value.substring(selectionStart, selectionEnd)

        // Create a regular expression to find whole words that match the selected text, case-insensitive
        const regex = new RegExp(`\\b${selectedText}\\b`, 'gi')

        // Replace all matching whole words in the text
        const newValue = value.replace(regex, `[[${selectedText}]]`)

        // Update the state
        setSearchString(newValue)
    }

    const handleSearchLanguageChange = event => {
        setSearchLanguage(event.target.value)
    }

    const handleSearchCountryChange = event => {
        setSearchCountry(event.target.value)
    }

    React.useEffect(() => {
        switch (activeStep) {
            case 0:
                setActiveImportDialog('import')
                break
            case 1:
                if (!presetContext) {
                    setSelectedContext(generatePresetContext())
                }

                break
            case 2:
                if (!searchString) {
                    setErrorMessage(
                        `Please, provide a search query you'd like to get results from AI for.`
                    )
                    setActiveStep(1)
                    break
                }
                if (!selectedContext) {
                    setErrorMessage(
                        'Please, select the graph to import your data to.'
                    )
                    setActiveStep(1)
                    break
                }
                if (selectedContext) {
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
                setActiveStep(1)
                break
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    const handleAiTopicsClick = React.useCallback(() => {
        setActiveSubImportDialog(false)
        setActiveImportDialog('aiOntologies')
    }, [])

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Create a knowledge graph from text'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 1 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <DialogContentText>
                                Use [[wiki links]] or #hashtags to create nodes.
                                To link nodes, use them in the same sentence.
                            </DialogContentText>
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={7}>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 2 }}
                                    >
                                        <TextField
                                            label={
                                                'add your text here, use [[wiki links]] to link [[entities]], double-click to tag'
                                            }
                                            value={searchString}
                                            variant="outlined"
                                            onChange={handleSearchStringChange}
                                            onSelect={handleSearchStringSelect}
                                            aria-describedby="searchString-helperText"
                                            placeholder="use [[wiki links]] in the [[same sentence]] to link them"
                                            multiline
                                            rows={8}
                                            onKeyDown={handleWikiTab}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.main',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderWidth: 2,
                                                        borderColor:
                                                            'info.dark',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderWidth: 2,
                                                    },
                                                    '& .MuiInputBase-inputMultiline': {
                                                        boxShadow:
                                                            'none !important',
                                                        border:
                                                            'none !important',
                                                    },
                                                },
                                            }}
                                        />
                                    </FormControl>
                                    <FormHelperText
                                        id="searchString-helperText"
                                        sx={{ marginTop: 2 }}
                                    >
                                        We will use the AI model you choose to
                                        generate an ontology based on the
                                        content you provide. For bigger texts
                                        and files, you can use our{' '}
                                        <a
                                            href="https://chatgpt.com/g/g-679925713a4c8191a0a8fbb1f97ff027-ontologies-generator"
                                            target="_blank"
                                        >
                                            Ontology Custom GPT
                                        </a>{' '}
                                        and paste the results here.
                                    </FormHelperText>
                                    <FormControl sx={{ marginTop: 4 }}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            onClick={handleAiTopicsClick}
                                        >
                                            or generate a knowledge graph with
                                            AI
                                        </Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <EditableSelect
                                            selectItems={contextNames}
                                            label={'Import To'}
                                            initialValue={selectedContext}
                                            onChange={name =>
                                                setSelectedContext(name)
                                            }
                                            aria-describedby="contextName-helperText"
                                            id="contextName"
                                        />
                                        <FormHelperText
                                            id="contextName-helperText"
                                            sx={{ marginTop: 2 }}
                                        >
                                            Please, choose the name of the graph
                                            to import your content to and click
                                            enter.
                                        </FormHelperText>
                                    </FormControl>
                                    <FormControl
                                        fullWidth
                                        sx={{
                                            marginTop: 4,
                                            marginBottom: 2,
                                        }}
                                    >
                                        <InputLabel id="modifyAnalyzedText-label">
                                            Build a knowledge graph from
                                        </InputLabel>
                                        <Select
                                            labelId="modifyAnalyzedText-label"
                                            id="modifyAnalyzedText"
                                            value={modifyAnalyzedText}
                                            onChange={event =>
                                                setModifyAnalyzedText(
                                                    event.target.value
                                                )
                                            }
                                            label="Build a knowledge graph from"
                                        >
                                            <MenuItem value={'none'} key="1">
                                                only your own [[tagged
                                                entities]]
                                            </MenuItem>
                                            <MenuItem
                                                value={'detectEntities'}
                                                key="2"
                                            >
                                                your own and automatically
                                                detected entities
                                            </MenuItem>
                                            <MenuItem
                                                value={'extractEntitiesOnly'}
                                                key="3"
                                            >
                                                automatically [[tagged
                                                entities]] only
                                            </MenuItem>
                                        </Select>
                                        {modifyAnalyzedText != 'none' && (
                                            <FormHelperText
                                                sx={{ marginTop: 1 }}
                                            >
                                                Note that with this option
                                                selected, we will modify the
                                                text you provide and
                                                automatically tag entities using
                                                [[wiki links]].
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                    {modifyAnalyzedText != 'none' && (
                                        <FormControl
                                            fullWidth
                                            sx={{
                                                marginTop: 2,
                                                marginBottom: 2,
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        id="replaceEntities"
                                                        checked={
                                                            replaceEntities
                                                        }
                                                        onChange={event =>
                                                            setReplaceEntities(
                                                                event.target
                                                                    .checked
                                                            )
                                                        }
                                                    />
                                                }
                                                label="Replace entities with root concepts"
                                            />
                                            {replaceEntities && (
                                                <FormHelperText
                                                    id="replaceEntities-helperText"
                                                    sx={{ marginTop: 1 }}
                                                >
                                                    When turned on, we will not
                                                    only detect the entities,
                                                    but also replace them with
                                                    their ontological root
                                                    concepts throughout your
                                                    text.
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}
                {activeStep === 2 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/mindmap`}
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>
                    {/* {isStepOptional(activeStep) && (
                        <Button
                            color="inherit"
                            onClick={handleSkip}
                            sx={{ mr: 1 }}
                        >
                            Skip
                        </Button>
                    )} */}
                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!searchString.length > 0}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function generatePresetContext(searchString) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    if (!searchString) return `pkm_${dateAndTime}`

    const twoFirstSearchQueryWords = slugifyString(
        searchString
            .split(' ')
            .slice(0, 3)
            .join('_')
            .slice(0, 25)
            .replace(/[^\P{L}a-z][^a-z]*/giu, '')
    )

    return `pkm_${twoFirstSearchQueryWords}`
}
